import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
/**
 * PATCH /api/v2/process/:processId/draft/resurvey-all — request.
 * Flags (value: true) or clears (value: false) the survey re-request on every
 * survey-eligible draft step at once; applied on publish (ADR 0009).
 */ export const SetDraftResurveyAllRequestSchema = z.object({
    value: z.boolean()
});
export const SetDraftResurveyAllResponseSchema = z.object({
    stepsFlagged: z.number()
});
export const SetDraftResurveyAllErrorSchema = BaseErrorSchema;

//# sourceMappingURL=set-draft-resurvey-all.schema.js.map